export default __webpack_public_path__ + "static/appalachian-smash-thumbnail-99a63146af24ab9e3795acf98dfe303a.jpg";